<template>
    <div class="market-details-page">
        <!-- 头部组件 -->
        <Header />
        <div>
            <!-- 导航路径 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{
                        name: 'home', params: {
                            activeName: '4',
                        },
                    }">看行情</el-breadcrumb-item>
                    <el-breadcrumb-item>行情详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 主要内容 -->
            <div class="main-content">
                <!-- 行情标题 -->
                <div class="section-title">
                    <div class="title-container">
                        <div class="line"></div>
                        <span>行情详情</span>
                    </div>
                </div>

                <!-- 行情图表和信息区域 -->
                <div class="market-container">
                    <!-- 左侧图表区域 -->
                    <div class="chart-section">
                        <!-- 查看按钮 -->
                        <!-- <div class="chart-header">
                            <span class="view-link">看行情 ></span>
                            <span class="view-link">行情详情</span>
                        </div> -->

                        <!-- ECharts图表容器 -->
                        <div class="chart-container">
                            <div id="lineChart" style="width: 100%; height: 300px;"></div>
                            <div class="chart-title">{{ marketInfo.name }} 近七日行情走势图</div>
                        </div>
                    </div>

                    <!-- 右侧信息面板 -->
                    <div class="info-section">
                        <!-- 今日/昨日行情 -->
                        <div class="info-card">
                            <div class="card-title">今日/昨日行情</div>
                            <div class="info-item">
                                <span class="info-label">昨日平均单价(元):</span>
                                <span class="info-value">{{ marketInfo.yesterday_price || '0' }}/{{ marketInfo.unit
                                    || '斤' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">今日平均单价(元):</span>
                                <span class="info-value">{{ marketInfo.price || '0' }}/{{ marketInfo.unit || '斤'
                                    }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">升/降:</span>
                                <span class="info-value price-up"
                                    :style="{ 'color': marketInfo.is_up == 1 ? 'green' : marketInfo.is_up == 2 ? '#999999' : 'red' }"><span>{{
                                        marketInfo.is_up == 1 ? '降' :
                                            marketInfo.is_up ==
                                                2 ? '平稳' : '升' }}</span> <span>{{ marketInfo.is_up == 2 ? '' :
                                            marketInfo.ratio }}</span></span>
                            </div>
                        </div>

                        <!-- 近7日行情 -->
                        <div class="info-card">
                            <div class="card-title">近7日行情</div>
                            <div class="info-item">
                                <span class="info-label">近七日最高价(元):</span>
                                <span class="info-value">{{ maxPrice || '0.00' }}/{{ marketInfo.unit || '斤' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">近七日最低价(元):</span>
                                <span class="info-value">{{ minPrice || '0.00' }}/{{ marketInfo.unit || '斤' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">近七日均价(元):</span>
                                <span class="info-value">{{ avgPrice || '0.00' }}/{{ marketInfo.unit || '斤' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入头部和底部组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
// 导入ECharts
import * as echarts from 'echarts'

export default {
    name: 'MarketDetailsPage',
    components: {
        // 注册头部组件
        Header,
        // 注册底部组件
        Footer
    },
    data() {
        return {
            // 可以在这里添加数据
            marketInfo: {},
            marketList: [],
            chart: null
        }
    },
    computed: {
        maxPrice() {
            if (!this.marketList.length) return 0;
            return Math.max(...this.marketList.map(item => Number(item.price)));
        },
        minPrice() {
            if (!this.marketList.length) return 0;
            return Math.min(...this.marketList.map(item => Number(item.price)));
        },
        avgPrice() {
            if (!this.marketList.length) return 0;
            const sum = this.marketList.reduce((acc, item) => acc + Number(item.price), 0);
            return (sum / this.marketList.length).toFixed(2);
        },
        chartData() {
            // 将marketList转换为ECharts所需的数据格式
            return {
                categories: this.marketList.map(item => item.today),
                series: this.marketList.map(item => Number(item.price))
            };
        }
    },
    mounted() {
        // 初始化图表
        this.initChart();
    },
    created() {
        // 页面加载时的逻辑
        this.getMarketInfo();
    },
    methods: {
        // 初始化图表
        initChart() {
            // 获取DOM容器
            const chartDom = document.getElementById('lineChart');
            // 初始化ECharts实例
            this.chart = echarts.init(chartDom);

            // ECharts配置项
            const option = {
                // 标题配置
                title: {
                    text: '',
                    left: 'center'
                },
                // 提示框配置
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}: {c}元'
                },
                // 图例配置
                legend: {
                    show: false
                },
                // 网格配置
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '15%',
                    containLabel: true
                },
                // x轴配置
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.chartData.categories,
                    axisLine: {
                        lineStyle: {
                            color: '#CCCCCC'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: '#666666'
                    }
                },
                // y轴配置
                yAxis: {
                    type: 'value',
                    min: 0,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#CCCCCC'
                        }
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: '#666666',
                        formatter: '{value}元'
                    }
                },
                // 系列配置
                series: [{
                    name: '价格',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 5,
                    lineStyle: {
                        color: '#286CED',
                        width: 2
                    },
                    itemStyle: {
                        color: '#286CED'
                    },
                    areaStyle: {
                        opacity: 0
                    },
                    data: this.chartData.series
                }]
            };

            // 设置配置项
            this.chart.setOption(option);

            // 监听窗口大小变化，自动调整图表大小
            window.addEventListener('resize', () => {
                if (this.chart) {
                    this.chart.resize();
                }
            });
        },
        // 更新图表
        updateChart() {
            if (this.chart) {
                this.chart.setOption({
                    xAxis: {
                        data: this.chartData.categories
                    },
                    series: [{
                        data: this.chartData.series
                    }]
                });
            }
        },
        // 获取行情详情信息
        getMarketInfo() {
            this.$api.getMarketInfo({
                goodscategory_id: this.$route.query.id
            }).then(res => {
                this.marketInfo = res.detail;
                this.marketList = res.list;

                // 数据加载完成后更新图表
                this.$nextTick(() => {
                    this.updateChart();
                });
            }).catch(err => {
                this.$message.error(err);

                // 使用模拟数据
                this.useMockData();
            });
        },
        // 使用模拟数据
        useMockData() {
            this.marketList = [];
            // 更新图表
            this.$nextTick(() => {
                this.updateChart();
            });
        }
    },
    // 组件销毁时销毁图表实例
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    }
}
</script>

<style scoped>
.market-details-page {
    background-color: #f5f7fa;
    min-height: 100vh;
}

.breadcrumb {
    padding: 24px 0 20px 0;
    width: 1200px;
    margin: 0 auto;
}

.main-content {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 40px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.title-container {
    display: flex;
    align-items: center;
}

.line {
    width: 4px;
    height: 18px;
    background: #286CED;
    margin-right: 12px;
}

.market-container {
    display: flex;
    gap: 20px;
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.chart-section {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.chart-header {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    font-size: 14px;
}

.view-link {
    color: #286CED;
    cursor: pointer;
}

.chart-container {
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.chart-title {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
}

.info-section {
    width: 300px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.info-card {
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    padding: 20px;
}

.card-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
    color: #333;
}

.info-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-size: 14px;
}

.info-label {
    color: #666;
}

.info-value {
    color: #333;
    font-weight: 500;
}

.price-up {
    color: #ff4757;
}

/* 响应式设计 */
@media (max-width: 1200px) {

    .breadcrumb,
    .main-content {
        width: 100%;
        padding: 0 20px;
    }

    .market-container {
        flex-direction: column;
    }

    .info-section {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .chart-container {
        padding: 10px;
    }

    .info-card {
        padding: 15px;
    }
}
</style>